import React from 'react';
import './App.css';
import Router from './routes';
import { AuthProvider } from './shared/authentications/auth-context';
import { BrowserRouter } from 'react-router-dom';
import Moment from "moment-timezone";

function App() {
  Moment.tz.setDefault("Asia/Bangkok");
  return (
    <AuthProvider>
      <BrowserRouter>
        <Router/>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
